export const investTypes =  [
    {
      name: "课程联营",
      value: 1,
    },
    {
      name: "场地联营",
      value: 2,
    }
  ]



  export const mechanismUnionType =  [
    {
      name: "驻店教练",
      value: 'c_store',
    },
    {
      name: "类目主理教练",
      value: 'c_category',
    },{
      name: "合伙教练",
      value: 'c_owner',
    },
    {
      name: "运营主理人",
      value: 'o_manager',
    },
    {
      name: "运营合伙人",
      value: 'o_owner',
    }
  ]


 